import { render } from "./SidebarNav.vue?vue&type=template&id=4b295048"
import script from "./SidebarNav.vue?vue&type=script&lang=js"
export * from "./SidebarNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/greg/sites/queens/wp-content/themes/queens/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/sidebar-nav/SidebarNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b295048"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b295048', __exports__)) {
    api.reload('4b295048', __exports__)
  }
  
  module.hot.accept("./SidebarNav.vue?vue&type=template&id=4b295048", () => {
    api.rerender('4b295048', render)
  })

}


export default __exports__